
	import ctrlMixins from './_mixins.js'
	import urlUtil from './../util-url.js'
	// @ts-ignore
	import tip from './../tip.vue'
	// @ts-ignore
	import { ctrlParamsForAll } from './_common-stuff.ts';
	import { UarmCtrlComponentMeta, UarmCtrlParamsFileUpload, FileUploadServerMeta } from '@uarmSrc/types';

	var colname_name = 'name';
	var colname_size = 'size';
	var colname_width = 'width';
	var colname_height = 'height';
	var colname_formatId = 'format_id';
	var colname_formatGroupId = 'format_group_id'; // 'gr_format_id';
	var IMAGE_FILE_GROUP_ID = 1; // айди записи из CHAM_FILE_GROUP

	const defaultMaxSize = 80000;

	/** Это наше кастомное поле, т.е. vue не использует их в конфигурации компонента */
	const meta: UarmCtrlComponentMeta = {
		title: 'Файл',
		params: {
			allowedExtensions: {
				name: 'Список форматов через запятую',
				editType: 'input'
			},
			imageResize: {
				name: 'Ресайз картинок (безусловный)',
				editType: 'imageResizeEditor',
				tip: 'Ресайз до заданных в метаданных размеров. Задаётся макс. высота и/или макс. ширина. Картинка будет отресайзена с сохранением соотношения сторон'
			},
			maxSize: {
				name: 'Максимальный размер, кб',
				editType: 'input',
				tip: `По умолчанию: ${defaultMaxSize}`,
			},
			imageSizeImmutable: {
				name: 'Размеры изображений не редактируются',
				editType: 'checkbox'
			},
			isReadOnly: {
				name: 'Только просмотр/скачивание',
				editType: 'checkbox'
			},
			isRestrictedMedia: {
				name: 'Ограничить доступ',
				editType: 'checkbox'
			},
			isGlobalRestrictedMediaGroup: {
				name: 'Использовать глобальную группу',
				editType: 'checkbox'
			},
			securityInfoArmId: {
				name: 'Номер родительского АРМ для получения группы доступа',
				editType: 'number',
				tip: 'Числовое значение - номер любого из родительских АРМ, в котором есть контрол редактирования прав и поле для колонки, привязанной к контролу "Доступ"'
			},
			restrictedMediaGroup: {
				name: 'Допущенная группа',
				editType: 'input'
			},
			isNavGroup: {
				name: 'При скачивании с морды проверять права доступа к файлу',
				editType: 'checkbox',
				tip: 'Отдельная самостоятельная проверка, зависит от прав на разделы навигации, пока сделана только для Совета директоров.'
			},
			preserveCardUpload: {
				name: 'Сохранить возможность добавления файлов через карточку',
				editType: 'checkbox',
				tip:
					'Если активно, то можно будет загружать файлы через карточку (иконка +) и сразу несколько файлов (иконка папки). Ставится только в контроле в карточке!'
			},
			imagePreview: {
				name: 'Превью для изображения',
				editType: 'imagePreview',
				tip:
					'Превью может быть несколько, для каждого из них можно задать размеры и выбрать колонку, куда они сохранятся'
			},
			...ctrlParamsForAll,
		}
	}

	export default {
		name: 'ctrl_file_upload',
		mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {},
			//record_data: {},
		},
		meta,
		data: function(){
			//var colname = this.$props.field_meta.dbcolname;

			const c_ctrlParams: UarmCtrlParamsFileUpload = this.$props.field_meta.ctrlParams; // компьютед в data() пока недоступен

			const fileMeta: FileUploadServerMeta = this.$props.value || {};
			const isImage = fileMeta[colname_formatGroupId] === IMAGE_FILE_GROUP_ID;
			const fileExt = fileMeta.file_name?.toUpperCase?.()?.split?.('.')?.reverse?.()?.[0];

			var imgSize_height;
			if (fileMeta[colname_height]) {
				imgSize_height = fileMeta[colname_height]
			}
			else {
				imgSize_height = '';
			}

			var imgSize_width;
			if (fileMeta[colname_width]) {
				imgSize_width = fileMeta[colname_width]
			}
			else {
				imgSize_width = '';
			}

			const isRestrictedMedia = c_ctrlParams?.isRestrictedMedia === true;

			let context = urlUtil.mediaContextApi
			if (isRestrictedMedia) {
				context = urlUtil.restrictedMediaContext
			}

			const mediaLink = context + fileMeta.fileId;

			// console.log(isRestrictedMedia, mediaLink, !!(this.$props.value && this.$props.value[colname_size]))

			return {
				VALIDATION_ERROR: '',
				imageIsCropped: true,
				fileWasPicked: false,
				isRemove: false,
				isImage,
				fileExt, // uppercase!
				imgSize_height,
				imgSize_width,
				ctrlFileName: fileMeta.file_name || fileMeta.name || '',
				isPreviouslyUploaded: !!(this.$props.value && this.$props.value[colname_size]),
				isRestrictedMedia,
				mediaLink,
				previewLink: mediaLink + '?action=view' + '&' + new Date().getTime(),
				downloadLink: mediaLink + '?action=download',
				maxSize: c_ctrlParams.maxSize || defaultMaxSize, // PIRS2018-3213
			}
		},
		mounted: function(){
			if (this.$parent.$props.pick_type && this.$parent.$props.record_id === 0) {
				// спец случай: загрузка записи в tinyMCE по кнопке "выбрать файл с диска"
				// НЕ РАБОТАЕТ! https://stackoverflow.com/a/29873845
				this.$refs.inputRef.click();
			}
		},
		components: {
			tip
		},
		computed: {
			fileMeta: function (): FileUploadServerMeta{
				return this.$props.value || {};
			},
			EXT_hasFile: function(){ // используется снаружи! TODO сделать EXT_
				return this.$data.isPreviouslyUploaded || this.$data.fileWasPicked;
			},
			imageStyle: function() {
				if (this.$data.imageIsCropped) {
					return {
						'max-width': '500px',
						'max-height': '700px'
					}
				}
				else {
					const fileMeta: FileUploadServerMeta = this.$props.value || {};
					const s: Partial<{width: string, height: string}> = {};
					if (fileMeta[colname_width]) {
						s.width = fileMeta[colname_width] + 'px';
					}
					if (fileMeta[colname_height]) {
						s.height = fileMeta[colname_height] + 'px';
					}
					return s;
				}
			},
			c_fileId: function(){
				var id;
				if (this.$props.value) {
					id = this.$props.value.fileId;
				}
				else {
					id = 0;
				}
				return id;
			},
			fileUrl: function(){
				var domain = urlUtil.isWizard ? '' : urlUtil.getDomain();
				// можно было бы вообще забить на строки выше и отдавать тупо
				// urlUtil.mediaContext + this.fileMeta.path
				// потому что домен для медиа в визарде будет дописан
				// редиректом, см. background.js
				// НО
				// хочется иметь возможность на вебе зайти по IP
				// http://172.22.2.52/uarm/#/card/9235/123
				// API будет работать по переменной WIZ_APIURL
				// а картинки - грузится также с этого хоста минуя прокси который поднят на 95

				// PIRS2018-6429 - isRestrictedMedia - если поле с параметром Ограничить доступ
				return domain + this.isRestrictedMedia ? this.mediaLink + '?' + new Date().getTime() : urlUtil.mediaContext + this.fileMeta.path + '?' + new Date().getTime();

				// Сброс кеша в электроне: require('electron').remote.getCurre.webContents.session.clearCache(function() {});

			},
			isPickType () {
				return Boolean(this.$parent.$props.pick_type)
			},
			isReadOnly () {
				return (this.c_ctrlParams.isReadOnly || (this.isPickType && this.view_type === 'list' && this.isForceStatic === false))
			},
			imageSizeIsImmutable () {
				return (this.c_ctrlParams && this.c_ctrlParams.hasOwnProperty('imageSizeImmutable') && this.c_ctrlParams.imageSizeImmutable === true)
			}
		},
		methods: {
			// PIRS2018-3213
			outputSize: function (sizeKb) {
				if (sizeKb >= 2048) {
					return Math.ceil(sizeKb / 1000) + ' МБ';
				}
				return sizeKb + ' кБ';
			},
			EXT_getFileFormdataObj: function(){ // используется снаружи! отдает готовый объект который понимает formdataUtil
				var fileObj = {
					IS_FILE_UPLOAD: true, // флаг-константа для util-formdata
					IS_REMOVE: this.$data.isRemove,
					FILE_PAYLOAD: this.$refs.inputRef.files[0],
					IS_PREVIOUSLY_UPLOADED: this.$data.isPreviouslyUploaded,
					height: this.$data.imgSize_height || null,
					width: this.$data.imgSize_width || null,
					file_name: this.$data.ctrlFileName,
					fileId: this.c_fileId,
				}

				if (this.field_meta.ctrlParams.isNavGroup){
					// @ts-expect-error
					fileObj.is_nav_group = true
				}

				return fileObj;
			},
			getFiles: function(){
				return !!this.$refs.inputRef && this.$refs.inputRef.files;
			},
			onFileChange: function(){
				var vm = this;
				var extListStr = this.field_meta.ctrlParams.allowedExtensions;
				var extList = extListStr ? extListStr.toUpperCase().replace(/\s/g, '').split(',') : [];
				var imageExtList = ['JPEG', 'JPG', 'PNG', 'GIF', 'WEBP', 'BMP', 'TIFF'];

				var files = this.getFiles();
				vm.$data.VALIDATION_ERROR = '';
				if (files.length !== 0) {
					this.$data.fileWasPicked = true;
				}
				for (var i = 0; i < files.length; i++) {
					var filename = files[i].name;
					vm.$data.ctrlFileName = filename;
					var ext = filename.toUpperCase().split('.').reverse()[0];
					vm.$data.fileExt = ext;

					vm.$data.isImage = imageExtList.indexOf(ext) !== -1;

					if (extList.length) {
						if (extList.indexOf(ext) === -1) {
							vm.$data.VALIDATION_ERROR = 'Файл «' + files[i].name + '» имеет недопустимое расширение. Допустимые расширения: ' + extList.join(', ');
							break
						}
					}

					if (files[i].size === 0) {
						vm.$data.VALIDATION_ERROR = 'Файл нулевого размера';
						break
					}

					var sizeKb = Math.ceil(files[i].size / 1000);
					// console.log(sizeKb, vm.maxSize)
					if (sizeKb > vm.maxSize) {
						vm.$data.VALIDATION_ERROR = 'Размер файла «' + files[i].name + '» равен ' + vm.outputSize(sizeKb) + ' и превышает масимально разрешенный (' + vm.outputSize(vm.maxSize) + ')';
						break
					}

					// если были размеры от предыдущего файла - сбрасываем, иначе отресайзится новый
					vm.$data.imgSize_height = '';
					vm.$data.imgSize_width = '';
				}

			},
			showMediaPopup: function(evt) {
				// PIRS2018-2028. Кошерно конечно было бы переделать на modal, но пока тупо как в старой админке
				evt.preventDefault();
				showCenteredPopup(this.$data.mediaLink, 'Изображение', 600, 600);
			},
		},
	}

	// Функция открытия нового окошка по центру экрана, оказалось что не так она и проста
	// https://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen
	function showCenteredPopup(url, title, w, h) {
		// Fixes dual-screen position                             Most browsers      Firefox
		var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		var systemZoom = width / window.screen.availWidth;
		var left = (width - w) / 2 / systemZoom + dualScreenLeft;
		var top = (height - h) / 2 / systemZoom + dualScreenTop;
		var props = 'scrollbars=yes, width=' + (w / systemZoom) + ', height=' + (h / systemZoom) + ', top=' + top + ', left=' +left;
		var newWindow = window.open(url, title, props);
		if (window.focus) {
			newWindow.focus()
		}
	}
